import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import AboutSection from '../components/AboutSection';
import BannerSection from '../components/BannerSection';
import DoctorsSection from '../components/DoctorsSection';
import BlogSection from '../components/BlogSection';
import Footer from '../components/Footer';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <HeroSection />
        <AboutSection />
        <BannerSection imageKey="banner1" />
        <DoctorsSection />
        <BannerSection imageKey="banner2" />
        <BlogSection />
      </main>
      <Footer />
    </div>
  );
};

export default HomePage;
